module.exports = __webpack_public_path__ + "static/media/equatorial-guinea.2cfb3aa1.svg";